/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */

'use client'

import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { removeLocaleFromPathname } from '@web/utils/supported-locales/index'
import type { MarketoFormHiddenField } from '../../../types'

const FormPageUrlField = ({ field }: { field: MarketoFormHiddenField }) => {
	const { register, setValue } = useFormContext()

	useEffect(() => {
		const { protocol, host, pathname } = window.location
		// Marketo campaigns expect a URL that does not include the locale.
		// This is because the campaigns were created prior to locales being
		// added to hashicorp.com paths. As a result, we need to strip out the
		// locale from the path in order for Marketo campaigns to work.
		// In the future, we should better understand why this dependency exists
		// and explore ways to make this less brittle.
		const pathnameWithoutLocale = removeLocaleFromPathname(pathname)
		const url = `${protocol}//${host}${pathnameWithoutLocale}`
		setValue(field.id, url)
	}, [])

	return <input type="hidden" {...register(field.id)} />
}

export default FormPageUrlField
